export const LOADING = "LOADING";
export const LEAD_DETAILS = "LEAD_DETAILS";
export const SAVE_CLIENT_NOTE = "SAVE_CLIENT_NOTE";
export const LEAD_EMPTY_ERROR_OBJ = "LEAD_EMPTY_ERROR_OBJ";
export const LEAD_DETAILS_ERROR = "LEAD_DETAILS_ERROR";
export const UPDATE_LEAD_DETAILS = "UPDATE_LEAD_DETAILS";
export const UPDATE_LEAD_DETAILS_ERROR = "UPDATE_LEAD_DETAILS_ERROR";
export const SAVE_CLIENT_NOTE_ERROR = "SAVE_CLIENT_NOTE_ERROR";

export const LEAD_NOTES = "LEAD_NOTES";
export const LEAD_NOTES_ERROR = "LEAD_NOTES_ERROR";
export const LEAD_NOTE_DETAIL = "LEAD_NOTE_DETAIL";
export const LEAD_NOTE_DETAIL_ERROR = "LEAD_NOTE_DETAIL_ERROR";

export const LEAD_REMARKS = "LEAD_REMARKS";
export const LEAD_REMARKS_ERROR = "LEAD_REMARKS_ERROR";
export const LEAD_REMARK_DETAIL = "LEAD_REMARK_DETAIL";
export const LEAD_REMARK_DETAIL_ERROR = "LEAD_REMARK_DETAIL_ERROR";
export const SAVE_CLIENT_REMARKS = "SAVE_CLIENT_REMARKS";
export const SAVE_CLIENT_REMARKS_ERROR = "SAVE_CLIENT_REMARKS_ERROR";

export const DELETE_LEAD_NOTE = "DELETE_LEAD_NOTE";
export const DELETE_LEAD_NOTE_ERROR = "DELETE_LEAD_NOTE_ERROR";

export const DELETE_LEAD_REMARKS = "DELETE_LEAD_REMARKS";
export const DELETE_LEAD_REMARKS_ERROR = "DELETE_LEAD_REMARKS_ERROR";

export const LEAD_TASKS_STATUS_LIST = "LEAD_TASKS_STATUS_LIST";
export const LEAD_TASKS_STATUS_LIST_ERROR = "LEAD_TASKS_STATUS_LIST_ERROR";

export const CREATED_LEAD_DETAILS = "CREATED_LEAD_DETAILS";
export const CREATED_LEAD_DETAILS_ERROR = "CREATED_LEAD_DETAILS_ERROR";

export const EMAIL_CONVERSATION_HISTORY = "EMAIL_CONVERSATION_HISTORY";
export const UNREAD_NOTIFICATIONS = "UNREAD_NOTIFICATIONS";
